import { useEffect, useState } from 'react';
import styles from './branches.module.scss';
import { BranchesProps } from '../../../interfaces/pages';
import ProfileCard from "../../../components/ProfileCard";
import ButtonShared from '../../../components/Button/Button';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useToast } from '../../../helpers/hooks';
import { capitalize } from '../../../helpers/app';
import TextFieldShared from '../../../components/TextField/TextField';
import NoDataList from '../../../components/NoDataList/NoDataList';
import { images } from '../../../constants/images';
import SidebarContainer from '../../../containers/Profile/Branches/Sidebar/SidebarContainer';
import DeleteContainer from '../../../containers/Profile/Branches/Delete/DeleteContainer';

const Branches = ({
    user,
    branches,
    getBranches,
    cleanBranches
}: BranchesProps) => {
    const toast = useToast();
    const [sidebarState, setSidebarState] = useState<any>({open: false, type: "add"});
    const [search, setSearch] = useState<string>("");
    const [branchSelected, setBranchSelected] = useState<any>({});
    const [branchesAux, setBranchesAux] = useState<any>([]);
    const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);

    const handleKeyPressSearch = (value: any) => {
        let branchsFiltered = branches?.data;
        value = value.toLowerCase();
        setSearch(value);
        if(value){
            branchsFiltered = branches?.data && branches?.data.filter((item: any) => item?.name.toLowerCase().includes(value) || item?.contact?.name.toLowerCase().includes(value) || item?.contact?.last_name.toLowerCase().includes(value) || item?.contact?.email.toLowerCase().includes(value));
        }
        setBranchesAux(branchsFiltered);
    }

    const handleClickAdd = () => {
        setBranchSelected({});
        setSidebarState({open: true, type: "add"});
    }

    const handleClickEdit = (item: any) => {
        setBranchSelected(item);
        setSidebarState({open: true, type: "edit"});
    }

    const handleClickDelete = (item: any) => {
        setBranchSelected(item);
        setOpenModalDelete(true);
    }

    useEffect(() => {
        if(branches?.fetching === "failure"){
            toast("Ha ocurrido un error al mostrar las sucursales");
            cleanBranches();
        }
        if(branches?.fetching === "success"){
            setBranchesAux(branches?.data);
            cleanBranches();
        }
    }, [branches?.fetching]);

    useEffect(() => {
        if(user && user?.profile?.code !== "admin-brand"){
            getBranches(user?.dealership, "branches");
        }
    }, [])

    return (
        <>
        <SidebarContainer state={sidebarState} setState={setSidebarState} branchSelected={branchSelected} />
        <DeleteContainer 
            open={openModalDelete} 
            setOpen={setOpenModalDelete}
            branchSelected={branchSelected} 
            loading={branches?.delete?.fetching === "loading"}
        />
        {
            branches?.fetching === "loading"
            ?
                <div className={styles.loaderBranches} id="loaderBranches">
                    <CircularProgress 
                        size={styles.loader}
                        classes={{
                            colorPrimary: styles.loader
                        }}
                    />
                    <p>Cargando sucursales</p>
                </div>
            :
                (branches?.data && branches?.data.length === 0)
                ?
                    <div className={styles.noData}>
                        <NoDataList
                            title="Aún no tienes sucursales"
                            text="Añade una sucursal para ver los detalles en esta sección"
                            image={images.noBranches}
                            className={styles.message}
                        />
                        <ButtonShared
                            onPress={handleClickAdd}
                            title="Añadir"
                            icon={<AddIcon className={styles.iconButton} />}
                            primary
                        />
                    </div>
                :
                    <ProfileCard>
                        <div className={styles.branches} id="branchesContent">
                            <div className={styles.branchesContainer} id="branchesContent">
                                <div className={styles.header}>
                                    <ButtonShared
                                        onPress={handleClickAdd}
                                        title="Añadir"
                                        icon={<AddIcon className={styles.iconButton} />}
                                        className={styles.addButton}
                                        primary
                                        size="small"
                                        id="addBranch"
                                    />
                                    <TextFieldShared
                                        variant="search"
                                        label="Buscar"
                                        name="nameBranch"
                                        value={search}
                                        onChange={handleKeyPressSearch}
                                        className={styles.inputSearch}
                                    />
                                </div>
                                {
                                    branchesAux && branchesAux.length === 0
                                    ?
                                        search && <p className={styles.noDataSearch}>No se han encontrado sucursales</p>
                                    :
                                        <TableContainer className={styles.table}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className={styles.head}>
                                                        <TableCell className={styles.cell}>Sucursal</TableCell>
                                                        <TableCell className={styles.cell}>Contacto</TableCell>
                                                        <TableCell className={styles.cell}>Mail</TableCell>
                                                        <TableCell className={styles.cell}>Teléfono</TableCell>
                                                        <TableCell className={styles.cell}></TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                <TableBody>
                                                {
                                                    branchesAux && branchesAux.map((item: any, index: number) => (
                                                        <TableRow key={index} className={styles.row}>
                                                            <TableCell className={styles.cell}>
                                                                <p className={`${styles.branch} ${styles.text}`}>{capitalize(item?.name)}</p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <p className={`${styles.contact} ${styles.text}`}>{`${capitalize(item?.contact?.name)} ${capitalize(item?.contact?.last_name)}`}</p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <p className={`${styles.mail} ${styles.text}`}>{item?.contact?.email}</p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <p className={`${styles.phone} ${styles.text}`}>{`${item?.contact?.phone?.code} ${item?.contact?.phone?.number}`}</p>
                                                            </TableCell>
                                                            <TableCell className={styles.cell}>
                                                                <div className={styles.action}>
                                                                    <IconButton onClick={() => handleClickEdit(item)} className={styles.button}>
                                                                        <EditIcon className={styles.icon} />
                                                                    </IconButton>
                                                                    {/* <IconButton onClick={() => handleClickDelete(item)} className={styles.button}>
                                                                        <DeleteIcon className={styles.icon} />
                                                                    </IconButton> */}
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                }
                            </div>
                        </div>
                    </ProfileCard>
        }
        </>
    )
};
export default Branches;